import React, { useState, useEffect } from 'react'
import '../../plant-style.scss'
import {
  fetchInverterEnergyData,
  fetchEnergyMeterData,
  fetchGHIData,
  fetchGTIData,
  FetchActivePowerData,
  fetchGraphV2Data
} from '../../../../services/api'
import dayjs from 'dayjs'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import IconButton from '@mui/material/IconButton'
import useTechnicalViewGraphStyles from './styles'
import TechnicalGraphFilter from '../TechnicalGraphFilter/TechnicalGraphFilter'
import TechnicalGraphContainer from '../TechnicalGraphContainer/TechnicalGraphContainer'
import { LinearBuffer } from '../utils/LinearBuffer'

const TechnicalViewGraph = ({ state, plantContent, token }) => {
  const classes = useTechnicalViewGraphStyles()
  dayjs.locale()
  const [technicalFromDate, setTechnicalFromDate] = useState(
    dayjs().startOf('day')
  )
  const [technicalToDate, setTechnicalToDate] = useState(dayjs().endOf('day'))
  const [mapInverterSeries, setMapInverterSeries] = useState([])
  const [inverterviewbutton, setinverterviewbutton] = useState('day')
  const [selectedDeviceID, setSelectedDeviceID] = useState(1)
  const [selectedTypeID, setSelectedTypeID] = useState(1)
  const [selectedButtons, setSelectedButtons] = useState(['Inverter Energy'])
  const [open, setOpen] = useState(false)
  const [openTable, setOpenTable] = useState(false)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const [value, setValue] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [yaxisUnit, setYaxisUnit] = useState('kWh')
  const [type, setType] = useState('Inverter Energy')
  //const [canFetch, setCanFetch] = useState(false);

  //const PlantID = state?.id
  const PlantID = state?.id;
  console.log("Plant id in technicalviewg", PlantID)
  //const PlantID = '689be94d45893db3ed8b219b'
  const DEVID = state?.roofDetails?.[0]?.inverters?.[0]?.id
  const isButtonSelected = (buttonName) => selectedButtons.includes(buttonName)

  /*function calculateDateRange(duration, today) {
    let startDate, endDate

    if (duration === 'day') {
      startDate = today.startOf('day').toISOString()
      endDate = today.toISOString()
    } else if (duration === '1M') {
      startDate = today.startOf('month').toISOString()
      endDate = today.endOf('month').toISOString()
    } else if (duration === '3M') {
      startDate = today.subtract(3, 'month').startOf('month').toISOString()
      endDate = today.toISOString()
    } else if (duration === '6M') {
      startDate = today.subtract(6, 'month').startOf('month').toISOString()
      endDate = today.toISOString()
    } else if (duration === '1Y') {
      startDate = today.subtract(1, 'year').toISOString()
      endDate = today.toISOString()
    } else if (duration === 'YTD') {
      startDate = today.startOf('year').toISOString()
      endDate = today.toISOString()
    } else if (duration === 'MTD') {
      startDate = today.startOf('month').toISOString()
      endDate = today.toISOString()
    } else if (duration === 'custom') {
      const technicalFromDateObj = dayjs(technicalFromDate.$d)
      const technicalToDateObj = dayjs(technicalToDate.$d)
      startDate = technicalFromDateObj.toISOString()
      endDate = technicalToDateObj.toISOString()
    }

    return { startDate, endDate }
  }*/


  //updated for graph V2
  function calculateDateRange(duration, today) {
    const periodMap = {
      'day': 'today',
      '1M': '1m',
      '3M': '3m',
      '6M': '6m',
      '1Y': '1y',
      'YTD': 'ytd',
      'MTD': 'mtd',
      'custom': 'custom'
    };

    let startDate, endDate, period;

    period = periodMap[duration] || 'today';

    if (duration === 'custom') {
      startDate = dayjs(technicalFromDate.$d).format('YYYY-MM-DD');
      endDate = dayjs(technicalToDate.$d).format('YYYY-MM-DD');
    } else {
      startDate = today.format('YYYY-MM-DD');
      endDate = duration === 'custom' ? dayjs(technicalToDate.$d).format('YYYY-MM-DD') : '';
    }

    return { startDate, endDate, period };
  }

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  /*(() => {
    //setSelectedDeviceID(DEVID)
    //setSelectedButtons(['Inverter Energy'])
    if (DEVID && selectedTypeID) {
      setSelectedDeviceID(DEVID);
      setSelectedButtons(['Inverter Energy']);
      handleSelectInverter('Inverter Energy', 'day', DEVID, selectedTypeID)
    }
  }, [DEVID, selectedTypeID])*/

  useEffect(() => {
    handleSelectInverter('Inverter Energy', 'today', selectedDeviceID, selectedTypeID);
  }, []);
 

  //trigger date fetch after changes in CUST period
  useEffect(() => {
    if (inverterviewbutton === 'custom' && technicalFromDate && technicalToDate) {
      //slight delay for prooper state updates
      const timeoutId = setTimeout(() => {
        handleChangePreiod('custom');
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [technicalFromDate, technicalToDate, inverterviewbutton]);

  /*useEffect(() => {
    const fetchData = async () => {
      await handleSelectInverter(type, 'day')
    }
    fetchData()
  }, [])*/

 const handleSelectInverter = async (type, duration, deviceID, typeID) => {
  setIsLoading(true);

    const typeConfig = {
          GHI: { 
            name: 'GHI', 
            color: '#FF5733', 
            unit: 'kW/m²', 
            yAxisId: 1,
            dataType: 'ghi'
          },
          GTI: { 
            name: 'GTI', 
            color: '#33C4FF', 
            unit: 'kW/m²', 
            yAxisId: 1,
            dataType: 'gti'
          },
          'Inverter Energy': {
            name: 'Inverter Energy',
            color: '#4CAF50',
            unit: 'kWh',
            yAxisId: 0,
            dataType: 'inverter'
          },
          'Meter Energy': {
            name: 'Meter Energy',
            color: '#FFC107',
            unit: 'kWh',
            yAxisId: 0,
            dataType: 'energymeter'
          },
          'Active Power': {
            name: 'Active Power',
            color: '#9C27B0',
            unit: 'kW',
            yAxisId: 0,
            dataType: 'activepower'
          }
        };

      const config = typeConfig[type] || {
        name: type,
        color: '#4CAF50',
        unit: 'kWh',
        yAxisId: 0,
        dataType: 'inverter'
      };

      // Update yaxisUnit 
      if (selectedButtons.length <= 1 || selectedButtons[selectedButtons.length - 1].includes(type)) {
        setYaxisUnit(config.unit);
      }

      const updateSeries = (name, data, color, unit) => {
        setMapInverterSeries((prevSeries) => {
          const updatedSeries = prevSeries.filter((series) => series.name !== name);
          return [
            ...updatedSeries,
            {
              name,
              data,
              color,
              yAxisId: config.yAxisId,
              unit: unit,
            },
          ];
        });
      };

      function downsample(data, targetPoints) {
        if (!data || data.length === 0) return [];

        if (inverterviewbutton === 'day' || inverterviewbutton === 'today') {
          targetPoints = 500; //higher resolution for daily view
        }

        if (data.length <= targetPoints) return data; //return without downsampling
        
        const bucketSize = Math.ceil(data.length / targetPoints);
        const downsampled = [];

        for (let i = 0; i < data.length; i += bucketSize) {
          const slice = data.slice(i, i + bucketSize);
          const avgY = slice.reduce((sum, point) => sum + point.y, 0) / slice.length;

          downsampled.push({
            x: slice[0].x, //keep the first timestamp of the bucket
            y: avgY,
          });
        }

        return downsampled;
      }

      try {
        let today = dayjs();
        let startDate, endDate, period;

        //period type determine
        const periodMap = {
          'day': 'today',
          '1M': '1m',
          '3M': '3m',
          '6M': '6m',
          '1Y': '1y',
          'YTD': 'ytd',
          'MTD': 'mtd',
          'custom': 'custom'
        };

        period = periodMap[duration] || 'today';

        if (duration === 'custom') {
          startDate = dayjs(technicalFromDate.$d).format('YYYY-MM-DD');
          endDate = dayjs(technicalToDate.$d).format('YYYY-MM-DD');
        } else {
          startDate = today.format('YYYY-MM-DD');
          endDate = 'all'; 
        }

        console.log(`Fetching ${type} data with params:`, {
          plantId: PlantID,
          dataType: config.dataType,
          fromDate: startDate,
          period,
          toDate: endDate,
          duration,
          token,
        });

        const response = await fetchGraphV2Data(
          PlantID,
          config.dataType,
          startDate,
          period,
          token,
          'all', // roofId
          endDate, // toDate 
          'all' // deviceId
        );

        console.log(`Response for ${type} data:`, response);

        let responseData = response;
        let metadata = null;
        
        //Check for new structure
        if (response && response.data && Array.isArray(response.data)) {
          responseData = response.data;
          metadata = response.metadata;
          console.log(`${type} metadata:`, metadata);
        }

        if (responseData && Array.isArray(responseData)) {
          const needsConversion = metadata?.activePowerFieldName && 
            (metadata.activePowerFieldName === 'activePower' || 
             metadata.activePowerFieldName === 'active_power');
          
          if (needsConversion) {
            console.log("Active power converting to kWH...");
          }

        let processedData = responseData.map(entry => {
        let timestamp = new Date(entry.x).getTime();
        let yValue = entry.y || 0;
        
        if (needsConversion) {
          yValue = yValue / 1000;
        }

        //hardcoded wattmon plant
        if (PlantID === '68ad32a314753f023e77bdcf') {
           return {
            x: timestamp - (5.5 * 60 * 60 * 1000), 
            y: parseFloat(yValue)
          };
        } 
        
        return {
          x: timestamp,  
          y: parseFloat(yValue)
        };
      });


      if (period === 'custom') {
        processedData.sort((a, b) => a.x - b.x);
      }

      processedData = downsample(processedData, 200); //downsampled from 1600 to 400 datapoints for better

      updateSeries(config.name, processedData, config.color, config.unit);
      setYaxisUnit(config.unit);
    } else {
      console.warn(`No ${type} data received or data is empty`);
      updateSeries(config.name, [], config.color, config.unit);
    }
  } catch (error) {
    console.error(`Error fetching ${type} data:`, error);
    updateSeries(config.name, [], config.color, config.unit);
  } finally {
    setIsLoading(false);
  }
};

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const separateValues = (str) => {
    const [label, value] = str.split(' ')
    return { label, value }
  }

  const handleChangePreiod = (Period) => {
      selectedButtons.forEach((buttonName) => {
          handleSelectInverter(buttonName, Period, selectedDeviceID, selectedTypeID);
      });
  };

 const handleChooseDate = (value, type) => {
    if (type === 'from') {
      setTechnicalFromDate(value)
    } else if (type === 'to') {
      setTechnicalToDate(value)
    }
  }

  /*const handleButtonClick = (buttonName, deviceID, typeID) => {
    const devtype = buttonName

    if (selectedButtons.includes(buttonName)) {
      const updatedButtons = selectedButtons.filter((btn) => btn !== buttonName)
      setSelectedButtons(updatedButtons)
      setMapInverterSeries((prevSeries) =>
        prevSeries.filter((obj) => obj.name !== buttonName)
      )

      if (updatedButtons.length > 0) {
        //const remainingType = updatedButtons[0].split(' ')[0]
        const remainingType = updatedButtons[0]
        const unitMap = {
          GHI: 'kW/m²',
          GTI: 'kW/m²',
          'Inverter Energy': 'kWh', 
          'Meter Energy': 'kWh',   
          'Active Power': 'kW'   
        }
        setYaxisUnit(unitMap[remainingType] || 'kWh')
      } else {
        setYaxisUnit('kWh')
      }
    } else {
      setSelectedButtons([...selectedButtons, buttonName])
      setSelectedDeviceID(deviceID)
      setSelectedTypeID(typeID)
      setType(devtype)

      const unitMap = {
        GHI: 'kW/m²',
        GTI: 'kW/m²',
        'Inverter Energy': 'kWh',
        'Meter Energy': 'kWh',
        Inverter: 'kWh',
        Meter: 'kWh',
      }

      setYaxisUnit(unitMap[devtype] || 'kWh')
      handleSelectInverter(devtype, inverterviewbutton, deviceID, typeID);
    }
  }*/

    const handleButtonClick = (buttonName, deviceID, typeID) => {
    const unitMap = {
        'GHI': 'kW/m²',
        'GTI': 'kW/m²',
        'Inverter Energy': 'kWh',
        'Meter Energy': 'kWh',
        'Active Power': 'kW',
    };

    if (selectedButtons.includes(buttonName)) {
        const updatedButtons = selectedButtons.filter((btn) => btn !== buttonName);
        setSelectedButtons(updatedButtons);
        setMapInverterSeries((prevSeries) =>
            prevSeries.filter((obj) => obj.name !== buttonName)
        );

        if (updatedButtons.length > 0) {
            const remainingType = updatedButtons[0];
            setYaxisUnit(unitMap[remainingType] || 'kWh');
            handleSelectInverter(remainingType, inverterviewbutton, deviceID, typeID);
        } else {
            setYaxisUnit('kWh');
        }
    } else {
        setSelectedButtons([...selectedButtons, buttonName]);
        setSelectedDeviceID(deviceID);
        setSelectedTypeID(typeID);
        setType(buttonName);
        setYaxisUnit(unitMap[buttonName] || 'kWh');
        handleSelectInverter(buttonName, inverterviewbutton, deviceID, typeID);
    }
};

  const tabarr = [0]
  const dynamicHeadings = mapInverterSeries.map((item) => item.name)

  console.log('mapInverterSeries in TechnicalViewGraph:', mapInverterSeries)

  return (
    <div className={classes.root}>
      <div
        className="graph_bg mb_10"
        style={{ minHeight: '510px', backgroundColor: 'white' }}
      >
        <Dialog fullScreen open={open} onClose={handleClose}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogTitle />
          <DialogContent>
            <DialogContentText>
              <div className="graph_bg">
                <TechnicalGraphFilter
                  openTable={openTable}
                  setOpenTable={setOpenTable}
                  inverterviewbutton={inverterviewbutton}
                  technicalToDate={technicalToDate}
                  technicalFromDate={technicalFromDate}
                  handleChooseDate={handleChooseDate}
                  handleOpen={handleOpen}
                  mapInverterSeries={mapInverterSeries}
                  value={value}
                  handleChange={setValue}
                  tabarr={tabarr}
                  isButtonSelected={isButtonSelected}
                  handleButtonClick={handleButtonClick}
                  setTechnicalFromDate={setTechnicalFromDate}
                  setTechnicalToDate={setTechnicalToDate}
                  setinverterviewbutton={setinverterviewbutton}
                  handleChangePreiod={handleChangePreiod}
                />
                <TechnicalGraphContainer
                  openTable={openTable}
                  dynamicHeadings={dynamicHeadings}
                  mapInverterSeries={mapInverterSeries}
                  selectedButtons={selectedButtons}
                  yaxisUnit={yaxisUnit}
                  inverterviewbutton={inverterviewbutton}
                  technicalToDate={technicalToDate}
                  technicalFromDate={technicalFromDate}
                />
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <TechnicalGraphFilter
          openTable={openTable}
          setOpenTable={setOpenTable}
          inverterviewbutton={inverterviewbutton}
          technicalToDate={technicalToDate}
          technicalFromDate={technicalFromDate}
          handleChooseDate={handleChooseDate}
          handleOpen={handleOpen}
          mapInverterSeries={mapInverterSeries}
          value={value}
          handleChange={setValue}
          tabarr={tabarr}
          isButtonSelected={isButtonSelected}
          handleButtonClick={handleButtonClick}
          setTechnicalFromDate={setTechnicalFromDate}
          setTechnicalToDate={setTechnicalToDate}
          setinverterviewbutton={setinverterviewbutton}
          handleChangePreiod={handleChangePreiod}
        />

        {isLoading ? (
          <div
            style={{
              padding: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
              marginTop: '100px',
            }}
          >
            <LinearBuffer />
          </div>
        ) : (
          <TechnicalGraphContainer
            openTable={openTable}
            dynamicHeadings={dynamicHeadings}
            mapInverterSeries={mapInverterSeries}
            selectedButtons={selectedButtons}
            yaxisUnit={yaxisUnit}
            inverterviewbutton={inverterviewbutton}
            technicalToDate={technicalToDate}
            technicalFromDate={technicalFromDate}
          />
        )}
      </div>
    </div>
  )
}

export default TechnicalViewGraph